import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { APP_VALIDATION_REGEX } from 'src/app/app.contant';
import { ILineItemResultMap, ISupplierMarketResult } from '../../../models';
import { RfqService } from '../../../services/rfq/rfq.service';
import { PrBuyerHelperService } from '../../../services/pr-buyer-helper.service';

@Component({
  selector: 'app-send-vendor-email',
  templateUrl: './send-vendor-email.component.html',
  styleUrls: ['./send-vendor-email.component.scss'],
  changeDetection : ChangeDetectionStrategy.OnPush
})
export class SendVendorEmailComponent implements OnInit {

  public title !: string;
  public selectedVendor !: any;
  public lineItem_list!: any;
  public onClose = new BehaviorSubject<any>({});
  public line_items : any = [];
  public prId!: any;
  public lineItemDetails : any;
  public addRFQVendor:boolean = false;
  public emails :any = [];

  // form group
  public addVendorEmailForm !: FormGroup;
  public email_id: any;
  public selectedLineItemForm !: FormGroup;
  public selectedLineItem: any;
  
  public lineItemList: IMultiSelectOption[] = [];

  public mySettings: IMultiSelectSettings = {
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-primary btn-block text-white me-2',
    dynamicTitleMaxItems: 3,
    showCheckAll: true,
    showUncheckAll: true,
    displayAllSelectedText: true
  };
 
  public myTexts: IMultiSelectTexts = {
    defaultTitle: 'Select lineItems'
  };
  files: any;
  // public myTexts:any ='Select lineItems'

  constructor(
    public bsModalRef: BsModalRef,
    public rfqService: RfqService,
    public _prBuyerHelperService: PrBuyerHelperService,
    private _fb : FormBuilder) {
      this.addVendorEmailForm = this._fb.group({
        email_id : [[], [Validators.required, Validators.pattern(APP_VALIDATION_REGEX['EMAIL_PATTERN'])]]
      });
     }

  ngOnInit(): void {
    this.lineItemList = [...this.lineItem_list].map((item: any) => {
      return {
        'id':item,
        'name': item
      }
    });
    this.selectedLineItemForm = this._fb.group({
      selectedOptions: []
    })

    this.selectedLineItemForm.controls['selectedOptions'].valueChanges.subscribe((selected) => {
        console.log(this.selectedVendor, selected, 'selected');
        this.selectedLineItem = selected;
        this.rfqService.getMaterialDataForLineItem(this?.prId,selected).subscribe(
              (res:any)=>{
                if(res){
                  this.lineItemDetails = res.data;
                }
              }
            );
    })

    this.selectedVendor?.R3_S_EMAIL_ADDRESS && this.emails.push(this.selectedVendor?.R3_S_EMAIL_ADDRESS)
    console.log(this.lineItemList,this.selectedVendor, this.emails)
  }

  getFormArrayName(prop: string): any {
    const formArr =  this.addVendorEmailForm.controls[prop] as FormGroup;
    return formArr.controls
  }

  // public onChange(params: any) {
  //   console.log(this.line_items, 'line items', params);
    
  //   this.rfqService.getMaterialDataForLineItem(this.prId,this.line_items).subscribe(
  //     (res:any)=>{
  //       if(res){
  //         this.lineItemDetails = res.data;
  //         console.log(this.emails, 'emails');
          
  //       }
  //     }
  //   );
  //   // this.emails = this.emails.filter((email: any) => this.isValidEmail(email))
  // }


  public updateEmailInfo() : void {
    const formValue = this.addVendorEmailForm.getRawValue();
    this.selectedVendor['R3_S_EMAIL_ADDRESS'] = this.emails?.map((email:any)=> email?.value ? email.value : email).toString();
    this.selectedVendor['EMAIL_ADDRESS'] = this.emails?.map((email:any)=> email?.value ? email.value : email).toString();
    console.log(this.selectedVendor, 'selected vendor');
    
    this.closeModal(this.selectedVendor);
  }

  public onModalClose(): void {
    this.bsModalRef.hide();
  }

  public closeModal(data ?: ILineItemResultMap) {
    data = {
      selectedVendor: this.selectedVendor,
      lineItemList: this.lineItemDetails,
      selectedLineItem: this.selectedLineItem,
    }
    this.files?.length?{...data, ...{files:this.files}}:'';
    this.onClose.next(data);
    this.bsModalRef.hide();
  }

  public openUploadFile(){
    const modal$ = this._prBuyerHelperService.openuploadQESAttachmentModal(true);
    modal$.subscribe((res: any) => {
      if(res) {
        this.files = res;
      }
    });
  }
}
